export const countSections = ()/* : number */ => {
  const pathname = window.location.pathname;

  if (pathname === '/') {
    return 0;
  }
  return window.location.pathname.split('/').length - 1;
};

export const getSection = (level/* : number */)/* : string */ => {
  const sections = window.location.pathname.split('/');
  return sections[level];
};

export const getQueryString = (name/* : string */)/* : string */ => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(name)/*  as string */;
};

export const getId = ()/* : string */ => {
  const level = countSections() === 2 ? 2 : 1;
  return getSection(level);
};
